import PublishUtils from '../helpers/PublishUtils'
import { ConfigurablePropsFromDescription, PresentConfigOptions, WidgetDescription } from '../helpers/widget'

type WidgetWithPubsubProps = {
  props: {
    pubsub: Record<string, unknown>
  }
}

export function postprocessWidgetConfig<T extends WidgetDescription<any, PresentConfigOptions, any>>(config: ConfigurablePropsFromDescription<T['variables']> | null, widgetDefinition: T, widget: WidgetWithPubsubProps) {
  if (config == null) {
    console.error(`null widget configuration found for a ${widgetDefinition.name}`)
    return {}
  }

  const newConfig = { ...config } as Record<string, any>
  const widgetDefinitionVariables = (widgetDefinition?.variables ?? [])

  interpolateTopicValues()
  applyDefaultValues()

  return newConfig

  function interpolateTopicValues() {
    for (const variable of widgetDefinitionVariables) {
      if (!variable.topicValueInterpolationEnabled) continue

      if (Array.isArray(newConfig[variable.name])) {
        newConfig[variable.name] = newConfig[variable.name].map((valueString: string) => PublishUtils.processStringForParameters(widget, valueString))
      } else if (typeof newConfig[variable.name] === 'string') {
        newConfig[variable.name] = PublishUtils.processStringForParameters(widget, newConfig[variable.name])
      }
    }
  }

  function applyDefaultValues() {
    for (const variable of widgetDefinitionVariables) {
      if (!variable.defaultValue) continue

      const currentValue = newConfig[variable.name]
      if (variable.type === 'select' && variable.options) {
        const possibleValues = variable.options.map(opt => opt.value)
        if (!possibleValues.includes(currentValue)) {
          if (currentValue != null) console.warn(`widget ${widgetDefinition.name} config value ${currentValue} is not one of possible values ${possibleValues.join(', ')} for variable ${variable.name}`)
          newConfig[variable.name] = variable.defaultValue
        }
      } else if (currentValue == null) {
        newConfig[variable.name] = variable.defaultValue
      }
    }
  }
}

